import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { acceptLaunchSession } from './app/config/launch-session';

acceptLaunchSession().then(() => bootstrapApplication(AppComponent, appConfig)).catch((err) => console.error(err));
